import AllEnterPrises from './AllEnterPrises';

export default AllEnterPrises;
